import {ColumnStartOrder, ColumnBib, ColumnName,  ColumnNoc,  ColumnWarnings } from "components/common/TableColumns"
import {ColumnRankRowSpan, ColumnStartOrderRowSpan, ColumnBibRowSpan, ColumnNocRowSpan, ColumnNameRowSpan, ColumnPtyRowSpan, ColumnBouldersColSpan, ColumnResultRowSpan, ColumnExpanderRowSpan, ColumnRankTotal, ColumnPtyTotal, ColumnResultBoulder, ColumnResultLead, ColumnResultTotal, ColumnQualification, ColumnQualificationRowSpan} from "./TableColumns"

export function boulderBoulderColumns(config) {
    let boulders = config?.filter(cfg => cfg?.code === 'BOULDER')?.sort((a, b) => a?.pos - b?.pos)?.map(i => ({pos: i?.pos, value : i?.value}));
    boulders = Array.isArray(boulders) && boulders.length > 0 ? boulders : [{pos:'1', value: '1'}, {pos:'2', value: '2'}, {pos:'3', value: '3'}, {pos:'4', value: '4'}];

    return (
        [
            ColumnRankRowSpan({}),
            ColumnStartOrderRowSpan({}),
            ColumnBibRowSpan({}),
            ColumnNocRowSpan({}),
            ColumnNameRowSpan({}),
            ColumnPtyRowSpan({}),
            ColumnBouldersColSpan({boulders: boulders}),
            ColumnResultRowSpan({}),
            ColumnQualificationRowSpan({}),
            ColumnExpanderRowSpan({})
        ]
    )
}

export function boulderLeadColumns(extraData, extraData2) {
    const totalResults = extraData2?.cumulativeResults?.results;
    const boulderResults = extraData?.results?.items;
    return (
        [
            ColumnRankTotal({totalResults: totalResults}),
            ColumnStartOrder({}),
            ColumnBib({label: "HeaderBibNoR"}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnPtyTotal({totalResults: totalResults}),
            ColumnWarnings({}),
            ColumnResultBoulder({boulderResults: boulderResults}),
            ColumnResultLead({}),
            ColumnResultTotal({totalResults: totalResults}),
            ColumnQualification({totalResults: totalResults})
        ]
    )
}
